import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const WingIcon = (props: WrappingIconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 5C5 4.44772 5.44772 4 6 4H9C9.55228 4 10 4.44772 10 5C10 5.55228 9.55228 6 9 6H7V17H18V15C18 14.4477 18.4477 14 19 14C19.5523 14 20 14.4477 20 15V18C20 18.5523 19.5523 19 19 19H6C5.44772 19 5 18.5523 5 18V5ZM12.9523 4.99998C12.9485 5.55225 13.393 6.00308 13.9453 6.00693L16.6247 6.02564L11.712 10.8702C11.3188 11.258 11.3144 11.8911 11.7022 12.2844C12.0899 12.6776 12.7231 12.682 13.1163 12.2943L17.9276 7.54967L17.9102 10.0417C17.9064 10.594 18.351 11.0448 18.9032 11.0487C19.4555 11.0526 19.9063 10.608 19.9102 10.0557L19.9443 5.16774C19.9492 5.12877 19.9519 5.08909 19.9521 5.04884C19.956 4.49657 19.5114 4.04574 18.9591 4.04188L13.9593 4.00698C13.407 4.00313 12.9562 4.44771 12.9523 4.99998Z"
      />
    </Icon>
  );
};
